module.exports = __webpack_public_path__ + "static/media/tile-metabolomics.0cea4694.svg";